<app-notifications class="descriptive-notification" #notification>
  <ng-container notification-content>
    <span class="fa fa-question-circle-o fa-2x"></span>
    <p class="description">{{ model.description }}</p>
  </ng-container>
</app-notifications>
